































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import superFieldInfoList from '@root/components/super-field-info-list/index.vue';
import mixedUtils from '@root/common/mixins/list-page/utils.js';
@Component({
  components: {
    superFieldInfoList
  }
})
export default class detailDialog extends Vue {
  dialogVisible = false;
  vm = null;
  // 是否编辑状态
  mixedUtils = mixedUtils;
  @Prop({
    default: () => ({})
  })
  detailModel!: Object;

  @Prop({
    default: false
  })
  superPowerMode?: Boolean;

  @Prop({
    default: () => ({})
  })
  UI?: Object;

  showDialog() {
    this.dialogVisible = true;
  }

  hideDialog() {
    this.dialogVisible = false;
  }

  mounted() {
    this.vm = mixedUtils.closestVM(this, 'filterParam');
    console.log('$attrs---:', this.$attrs);
    // mixedUtils.log(`mixedUtils.closestVM(_self,'filterParam')`, mixedUtils.closestVM(this, 'filterParam'))
    // mixedUtils.log('$attrs--:', this.$attrs, this.detailModel)
  }

  onConfirm() {
    // @ts-ignore
    this.$emit('confirm', event.target.nodeName.toUpperCase());
  }

  onCancel(event) {
    mixedUtils.log('event on cancel--:', event);
    // this.dialogVisible = false
    this.$emit('cancel', event.target.nodeName.toUpperCase());
  }
}
